export const config = {
  internalLookupPrefix: '[#]',
  externalLookupPrefix: '[*]',
  customValuePrefix: '[^]',
  multiValueDivider: '[/]',
  searchPrefix: '[?]',
  notApplicableFieldSuffix: '_notApplicable',
  /** Server-side segment marking an item's Not Applicable details subtree (IFormSectionItem.NA_IDENTIFIER). */
  notApplicableDetailsIdentifier: '$NA',
  shouldValidateFieldSuffix: '_shouldValidate',
  /** Synthetic Formik field gating a staged group's visible first-stage rules (not sent to API). */
  validateFirstStageFieldSuffix: '_validateFirstStage',
  requiredFieldSuffix: '_required',
  instanceHasValueFieldSuffix: '_instanceHasValue',
  atLeastOneCompleteFieldSuffix: '_atLeastOneComplete',
  minFilesCountFieldSuffix: '_minFilesCount',
  loginFieldQuestionTypeSuffix: '_loginFieldType',
  questionWithDetailsFieldSuffix: '_questionWithDetails',
  /** Synthetic Formik field for the group-level AtLeastOneChildWithValue restriction (not sent to API). */
  atLeastOneChildWithValueFieldSuffix: '_atLeastOneChildWithValue',
  /** Synthetic Formik field for the group-level AtLeastOneChildAnsweredYes restriction (not sent to API). */
  atLeastOneChildAnsweredYesFieldSuffix: '_atLeastOneChildAnsweredYes',
  /** Synthetic Formik field for the group-level RequiredWhenValue restriction (not sent to API). */
  requiredWhenValueFieldSuffix: '_requiredWhenValue',
  /** Synthetic Formik field carrying a limit amount's LimitPairs rule error (not sent to API). */
  limitRuleFieldSuffix: '_limitRule',
  /** An address group's source choice, sent to the API as `addressLink` with the group's id. */
  addressLinkFieldSuffix: '_addressLink',
  /** Synthetic Formik field gating the fields an address link hides (not sent to API). */
  addressFieldsShownFieldSuffix: '_addressFieldsShown',
  // OfficeHours: server itemID endings for a day's two time fields. On Call's client-only
  // field id is the From id plus `_onCall`, so `$from` still matches only the time field.
  officeHoursFromFieldIdentifier: '$from',
  officeHoursToFieldIdentifier: '$to',
  // OfficeHours: boolean toggle uses a suffixed Formik field name to avoid colliding with the time input.
  // The suffix is stripped before sending updates to the API (server itemID stays ..._$from / ..._$to).
  officeHoursOnCallFieldSuffix: '_onCall',
  // OfficeHours: Closed is a real, independent field (server itemID ends in $closed) — this is only
  // used to locate it inside a day's fields array, never stripped before sending to the API.
  officeHoursClosedFieldIdentifier: '$closed',
  formChangeTrackerDebounceTime: 2000,
  /** Longest an edit waits for the debounce while the provider keeps typing. */
  formChangeTrackerMaxWait: 10000,
};
